export default __webpack_public_path__ + "static/media/fMaltoBuza6.78145451.png";